document.addEventListener('DOMContentLoaded', function() {
  const waitForElement = (selector, timeout = 10000) => {
    return new Promise((resolve, reject) => {
      const startTime = Date.now();
      const checkElement = () => {
        const element = document.querySelector(selector);
        if (element) {
          resolve(element);
          return;
        }

        if (Date.now() - startTime > timeout) {
          reject(new Error(`Element ${selector} not found within ${timeout}ms`));
          return;
        }

        setTimeout(checkElement, 100);
      };

      checkElement();
    });
  };

  const createDropdownMenu = (menuItems) => {
    if (!menuItems || menuItems.length === 0) {
      return null;
    }

    const dropdownContainer = document.createElement('div');
    dropdownContainer.className = 'breadcrumb-dropdown';

    menuItems.forEach((item, index) => {
      if (item.text && item.url) {
        const menuItem = document.createElement('a');
        menuItem.textContent = item.text;
        menuItem.href = item.url;
        menuItem.className = 'breadcrumb-dropdown-item';
        dropdownContainer.appendChild(menuItem);
      }
    });

    return dropdownContainer.children.length > 0 ? dropdownContainer : null;
  };

  const initBreadcrumbDropdown = async () => {
    try {
      const breadcrumbSection = document.querySelector('[data-breadcrumb-dropdown]');
      
      if (!breadcrumbSection) {
        return;
      }

      const enableDropdown = breadcrumbSection.getAttribute('data-enable-dropdown');
      
      if (enableDropdown !== 'true') {
        return;
      }

      const menuItemsData = breadcrumbSection.getAttribute('data-menu-items');
      let menuItems = [];
      
      if (menuItemsData) {
        try {
          menuItems = JSON.parse(menuItemsData);
        } catch (e) {
          return;
        }
      }

      if (!menuItems || menuItems.length === 0) {
        return;
      }

      const style = document.createElement('style');
      style.textContent = `
        .sf-breadcrumb__nav {
          display: flex !important;
          visibility: visible !important;
          opacity: 1 !important;
          height: auto !important;
          overflow: visible !important;
        }
      `;
      document.head.appendChild(style);

      const breadcrumb = await waitForElement('.sf-breadcrumb__nav');
      const allBreadcrumbItems = breadcrumb.querySelectorAll('.bread-crumb__item');
      const secondBreadcrumbItem = allBreadcrumbItems[1];

      if (!secondBreadcrumbItem) {
        return;
      }

      const dropdownMenu = createDropdownMenu(menuItems);
      if (!dropdownMenu) {
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.className = 'breadcrumb-hover-wrapper';
      const clonedBreadcrumb = secondBreadcrumbItem.cloneNode(true);

      secondBreadcrumbItem.parentNode.replaceChild(wrapper, secondBreadcrumbItem);
      wrapper.appendChild(clonedBreadcrumb);
      wrapper.appendChild(dropdownMenu);

      wrapper.addEventListener('mouseenter', () => {
        dropdownMenu.style.display = 'block';
      });

      wrapper.addEventListener('mouseleave', () => {
        dropdownMenu.style.display = 'none';
      });
    } catch (error) {
      return;
    }
  };

  initBreadcrumbDropdown();
}); 